import { render, staticRenderFns } from "./Cancellation.vue?vue&type=template&id=6389c638&scoped=true&"
import script from "./Cancellation.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Cancellation.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Cancellation.vue?vue&type=style&index=0&id=6389c638&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6389c638",
  null
  
)

export default component.exports